import { Box, Paper } from '@mui/material'
import { EthAddress } from '@xylabs/sdk-js'
import React from 'react'

import { EntityLoader } from '../../../Contexts'
import Summary from './Summary'

export interface EntityListItemProps {
  address: EthAddress
}

const EntityListItem: React.FC<EntityListItemProps> = (props) => {
  const { address } = props

  return (
    <Box component={Paper} flexGrow={1}>
      <EntityLoader address={address}>
        <Summary />
      </EntityLoader>
    </Box>
  )
}

export default EntityListItem
